import { BaseService } from './base'
import { APIPath } from '../constant/api'

class ActionPlan {
    getById(id) {
        return BaseService.get(`${APIPath.actionPlan}/GetById/${id}`)
    }

    create(data) {
        return BaseService.post(`${APIPath.actionPlan}/Create`, data)
    }

    getByQuestionId(questionId) {
        return BaseService.get(
            `${APIPath.actionPlan}/GetByQuestionId/${questionId}`,
        )
    }

    getByTemplateId(templateId) {
        return BaseService.get(
            `${APIPath.actionPlan}/GetByTemplateId/${templateId}`,
        )
    }

    update(data) {
        return BaseService.post(`${APIPath.actionPlan}/Update`, data)
    }

    delete(actionPlanId) {
        return BaseService.post(`${APIPath.actionPlan}/Delete`, {
            actionPlanId,
        })
    }

    getAssignedTickets(userId, pageNumber = 1, pageSize = 10, filters = null) {
        const startDate = filters?.startDate || ''
        const endDate = filters?.endDate || ''
        const customerIds = filters?.customerIds || ''
        const templateIds = filters?.templateIds || ''
        const ticketStatusIds = filters?.ticketStatusIds || ''

        return BaseService.get(
            `${APIPath.actionPlanAssignedTickets}/${userId}/Advance?pageNumber=${pageNumber}&pageSize=${pageSize}&startDate=${startDate}&endDate=${endDate}&customerIds=${customerIds}&templateIds=${templateIds}&ticketStatusIds=${ticketStatusIds}`,
        )
    }

    getMyTickets(userId, pageNumber = 1, pageSize = 10, filters = null) {
        const startDate = filters?.startDate || ''
        const endDate = filters?.endDate || ''
        const customerIds = filters?.customerIds || ''
        const templateIds = filters?.templateIds || ''
        const ticketStatusIds = filters?.ticketStatusIds || ''

        return BaseService.get(
            `${APIPath.actionPlanMyTickets}/${userId}?pageNumber=${pageNumber}&pageSize=${pageSize}&startDate=${startDate}&endDate=${endDate}&customerIds=${customerIds}&templateIds=${templateIds}&ticketStatusIds=${ticketStatusIds}`,
        )
    }

    getTicketStatus() {
        return BaseService.get(APIPath.actionPlanTicketStatus)
    }

    createResponse(payload) {
        return BaseService.post(APIPath.actionPlanResponseCreate, payload)
    }

    updateResponse(data) {
        return BaseService.post(APIPath.actionPlanResponseUpdate, data)
    }

    attachMediaToResponse(data) {
        return BaseService.post(APIPath.actionPlanResponseMediaAttach, data)
    }

    updateMediaReferences(mediaIds, referenceId) {
        const mediaIdsString = Array.isArray(mediaIds)
            ? mediaIds.join(';')
            : mediaIds
        return BaseService.post(
            `${APIPath.actionPlanMediaUpdate}?mediaIdsString=${mediaIdsString}&referenceId=${referenceId}`,
        )
    }

    getByUId(uid) {
        return BaseService.get(`${APIPath.actionPlan}/GetByUId/${uid}`)
    }

    getSignature(uid) {
        return BaseService.get(`${APIPath.actionPlanGetSignature}${uid}/Signature`)
    }

    updateSignature(data) {
        return BaseService.post(APIPath.actionPlanUpdateSignature, data)
    }
}

const actionPlanService = new ActionPlan()
Object.freeze(actionPlanService)
export { actionPlanService as ActionPlanService }
